import { useTranslation } from 'react-i18next';

import { kpiDelta, kpiLabel } from '../../model/kpi';
import type { Kpi as KpiData } from '../../types';
import { Kpi } from '@/shared/ui/atoms/Kpi';
import './KpiRow.styl';

type Props = { kpis: KpiData[]; columns?: 4 | 5 };

const arrow = (tone: KpiData['tone']) => (tone === 'up' ? '▲ ' : tone === 'down' ? '▼ ' : '');

/** A row of headline numbers. Risk-toned KPIs (a "down" on something that should not drop) get the risk frame. */
export function KpiRow({ kpis, columns = 4 }: Props) {
  // Re-render on language change; labels come from the backend vocabulary.
  useTranslation();
  return (
    <div className={`f-kpis f-kpis--${columns}`}>
      {kpis.map((k) => {
        const risk = k.tone === 'down' && /risk|overdue|rework/i.test(k.label);
        return (
          <Kpi
            key={k.label}
            value={k.value}
            label={kpiLabel(k.label)}
            {...(k.delta ? { sub: `${arrow(k.tone)}${kpiDelta(k.delta)}` } : {})}
            tone={k.tone}
            risk={risk}
          />
        );
      })}
    </div>
  );
}
